import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()
export class TimeService {
  

  constructor(private router: Router) { }

  /**
   * Calculate the time of the exam
   */
  dhms(t){
     let time : Date = new Date();
     let days, hours, minutes, seconds;
     days = Math.floor(t / 86400);
     if (t > 0) {
       t -= days * 86400;
       hours = Math.floor(t / 3600) % 24;
       t -= hours * 3600;
       minutes = Math.floor(t / 60) % 60;
       t -= minutes * 60;
       seconds = t % 60;
     }else{
       hours=0;minutes=0;seconds=0;
     }
     

     time.setHours(time.getHours()+hours);
     time.setHours(time.getMinutes()+minutes);
     time.setHours(time.getSeconds()+seconds);

     return [
             hours ,
             minutes ,
             seconds 
            ];                              
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/time.service.ts